import { render, staticRenderFns } from "./WarehousesCollection.vue?vue&type=template&id=53144789&"
import script from "./WarehousesCollection.vue?vue&type=script&lang=js&"
export * from "./WarehousesCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports